import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
    root: {
      '& input::placeholder': {
        color:'#00000099',
      },
    },
  });